import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, getUserFromLocalStorage } from "auth/authProvider";

/*function ProtectedRoute({ component: Component, ...rest }) {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      element={(props) => {
        return user ? <Component {...props} /> : <Navigate to="/login" />;
      }}
    />
  );
}*/

function PrivateRoute({ children }) {
  const { user } = useAuth();
  const userInLocalStorage = getUserFromLocalStorage();

  const navigate = useNavigate();

  useEffect(() => {
    if (!user && !userInLocalStorage) {
      navigate("/login");
    }
  }, [user]);

  //return user ? <Component /> : <Navigate to="/login" />;
  //if (!user && !userInLocalStorage) return <Navigate to="/login" />;

  return children;
}

export default PrivateRoute;
